"use client";

import type { ComponentType } from "react";

import { useLoyaltyWrapperContext } from "./LoyaltyWrapperContext";

export function withLoyaltyStore<P extends object>(Component: ComponentType<P>, name?: string): ComponentType<P> {
  return (props: P) => {
    const isInLoyaltyWrapper = useLoyaltyWrapperContext();

    if (!isInLoyaltyWrapper) {
      console.error(`Loyalty component '${name ?? "unknown"}' used outside of LoyaltyWrapper.`);
      return null;
    }

    return <Component {...props} />;
  };
}
